const errorMixin = {
  data () {
    return {
      showError: false,
      errObj: {
        status: '',
        error: ''
      }
    }
  },
  methods: {
    setError (err) {
      if (err.response) {
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
      throw err
    }
  }
}

export default errorMixin
